import { createNavigationContainerRef } from '@react-navigation/native';

/**
 * The navigation ref lives apart from the expo-router shim on purpose.
 *
 * That shim eagerly globs every module under `app/` to build its route table,
 * which drags in `db/client.ts` — and that opens the database at module scope.
 * The entry point needs the ref *before* storage is ready, so importing it
 * from here keeps the route graph (and the database) untouched until
 * `initSqlite()` has resolved.
 */
/**
 * Typed against an open route list. Without a parameter the ref is typed
 * against `{}`, so every route name narrows to `never` and the imperative
 * `router` helpers can only be written with casts — routes here are discovered
 * from the file system at runtime, so the names genuinely are open.
 */
export type AppParamList = Record<string, object | undefined>;

export const navigationRef = createNavigationContainerRef<AppParamList>();
